import { Component, ViewEncapsulation } from '@angular/core';
import { DetectScreenService } from '../../shop/services/detect-screen.service';

@Component({
  // encapsulation: ViewEncapsulation.None,
  selector: 'app-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html'
})

export class FooterComponent {

  public screenWidth: number;

  constructor(
    private detectScreen: DetectScreenService
  ) {
    this.screenWidth = this.detectScreen.getScreen();
    console.log(this.screenWidth);
  }
}
